import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Eclair = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43.68 79.22">
  <G fill={color}>
    <Path d="M43.34,27.39c-.5-.93-1.47-1.52-2.52-1.53l-11.57-.09L38.24,3.98c.37-.89.27-1.9-.27-2.7-.53-.8-1.43-1.28-2.4-1.28H7.92c-1.43,0-2.65,1.05-2.85,2.48L.03,37.76c-.12.82.13,1.66.67,2.29.54.63,1.33,1,2.16,1l7.27.05-3.72,34.94c-.14,1.32.64,2.57,1.89,3.02.32.12.65.17.97.17.95,0,1.86-.47,2.4-1.29l31.52-47.6c.58-.88.64-2.01.14-2.95Z"/>
  </G>
</Svg>
);
};

export default Eclair;
